// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceField__root___39MA-","priceForm":"PriceField__priceForm___Sw-J_","bordered":"PriceField__bordered___1pPNE","small":"PriceField__small___3_Tgr"};